import instance from '@/api/instance';

export let LoginDo = function (data) {
    return instance.post('/do/login', data)
}

export let AdminLogoutDo = function (data) {
    return instance.post('/do/logout', data)
}

export let AdminChangeTimezone = function (data) {
    return instance.post('/do/update/timezone', data)
}

export let AdminChangePassword = function (data) {
    return instance.post('/do/update/password', data)
}